<template>
  <div id="shiori-items">
    <!-- <h2 class="shiori-title-sub">【 持ち物 】 {{ shioriTitle }}</h2> -->
    <div id="items-box">
        <div class="item" v-for="(shioriItem, index) in shioriItems" :key="shioriItem.item">
          <p :class="shioriItem.color">{{ shioriItem.item }}</p>
          <button @click="deleteItem(index)"><i class="fas fa-trash-alt fa-fw"></i></button>
        </div>
    </div>
    <div class="about-add-btn-box">
      <button class="about-add-btn" @click="maskActive">追加</button>
    </div>
    <MovePageBtn v-show="spWidth" 
    :last-page="{name:movePage.name2, link:movePage.link2}" 
    :next-page="{name:movePage.name, link:movePage.link}"></MovePageBtn>
    <MaskBox v-show="maskOn" ></MaskBox>
    <InputItem 
    v-show="maskOn"
    @cancel="maskActive"
    @new-item="addNewItem"></InputItem>
  </div>
</template>

<script>
  import InputItem from './InputBoxes/InputItem.vue';


export default {
  props: {
    spWidth: {
      type: Boolean,
      required: true
    },
  },
  components: {
    InputItem
  },
  data() {
    return {
      maskOn: false,
      newItemObject: {},
      blueItems: [],
      redItems: [],
      greenItems: [],
      yellowItems: [],
      movePage: {
        name: "旅程",
        link: "/schedule",
        name2: "概要",
        link2: "/about",
      }
    }
  },
  computed: {
    shioriItems: {
      get() {
        return this.$store.getters.shioriItems;
      },
      set(value) {
        this.$store.commit('shioriItems', value);
      }
    }
  },
  methods: {
    maskActive() {
      this.maskOn = !this.maskOn;
    },
    addNewItem(inputItemColor, inputItemName) {
      this.newItemObject = {color:inputItemColor, item:inputItemName};
      this.shioriItems = [...this.shioriItems, this.newItemObject];
      this.blueItems = this.shioriItems.filter((obj) => obj.color === "blue");
      this.redItems = this.shioriItems.filter((obj) => obj.color === "red");
      this.greenItems = this.shioriItems.filter((obj) => obj.color === "green");
      this.yellowItems = this.shioriItems.filter((obj) => obj.color === "yellow");
      console.log(this.blueItems)
      this.shioriItems = this.blueItems.concat(this.redItems, this.greenItems, this.yellowItems);
      this.maskOn = !this.maskOn;
    },
    deleteItem(index) {
      const ret = confirm("削除してもよろしいですか？")
      if(ret === true) {
        this.shioriItems.splice(index, 1);
      } else {
        return;
      }
    },
  }
}
</script>